export default __webpack_public_path__ + "static/media/actividad-7.63e16d74.mp3";